import { ReactNode } from "react";
import { Box, Content, Heading } from "react-bulma-components";

import styled from "styled-components";

interface ErrorMessageProps {
  title: string;
  description: string;
  children?: ReactNode;
}

const StyledBox = styled(Box)`
  text-align: center;
`;

export const ErrorMessage = ({
  title,
  description,
  children = null
}: ErrorMessageProps) => {
  return (
    <StyledBox>
      <Heading className="mb-1" size={5}>
        {title}
      </Heading>

      <Content className="mb-2">{description}</Content>
      {children}
    </StyledBox>
  );
};

export default ErrorMessage;
